class videoHandler {
    constructor(instance) {
        this.$root = $(instance);
        this.$modal = null;
        this.player = null;
        this.tempScrollTop = 0;
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.$root.on("click", this._showPlayer.bind(this));
    }

    _showPlayer() {
        const modalTemplate = `
            <div class="reveal-overlay" style="display: block; z-index: 1011;">
                <div class="fil-modal fil-modal--rt-video reveal icon" style="display: block">
                    <video src="${this.$root.attr("data-src")}" controls autoplay ></video>
                    <button class="modal__exit" style="font-family: fidelity-icon-font!important;">
                        <span class="fil-icon fil-icon-cross-light" style="font-family: inherit!important;"></span>
                    </button>
                </div>
            </div>`;
        this.$modal = $(modalTemplate);
        this.$root.closest(".camc-retirement-trilogy__container").append(this.$modal);

        this.$modal.find(".modal__exit").on("click", () => {
            this._closePlayer();
        });

        this._disableScroll();
    }

    _closePlayer() {
        if (this.$modal && this.$modal.length) {
            this.$modal.remove();
            this._enableScroll(this.tempScrollTop);
        }
    }

    _disableScroll(scrollTop) {
        scrollTop = scrollTop || $(window).scrollTop();
        if ($(document).height() > $(window).height()) {
            $("html").css("top", -scrollTop);
            this.tempScrollTop = parseInt(-scrollTop, 10);
        }
        $("html").addClass("zf-has-scroll is-reveal-open");
    }

    _enableScroll(scrollTop) {
        $("html").removeClass("zf-has-scroll is-reveal-open");
        if ($(document).height() > $(window).height()) {
            $("html").css("top", "");
            $(window).scrollTop(-scrollTop);
        }
    }
}

export default videoHandler;
